import { RUSSIAN } from '../../../assets/images';
import { Section, TableOfContent } from '../../../typings/interfaces';
// Russian
const RUSection: Section[] = [
  {
    name: '1: Справка и общий обзор',
    subSections: [
      {
        name: 'Вступление',
        page: 3,
      },
      {
        name: 'Цель и применение справочника',
        page: 4,
      },
      {
        name: 'Основные понятия',
        page: 5,
      },
      {
        name: 'Иерархия средств контроля',
        page: 6,
      },
    ],
  },
  {
    name: '2: LIFESavers',
    subSections: [
      {
        name: 'Автомобильный транспорт — Безопасность дорожного движения',
        page: 9,
      },
      {
        name: 'Работы на высоте',
        page: 12,
      },
      {
        name: 'Передвижное оборудование (MPE)',
        page: 18,
      },
      {
        name: 'Отключение оборудования и размещение предупреждений (LOTO)/Изоляция линий электропитания',
        page: 22,
      },
      {
        name: 'Электротехнические работы',
        page: 25,
      },
      {
        name: 'Замкнутое пространство',
        page: 29,
      },
      {
        name: 'Транспортировка и хранение сыпучих материалов',
        page: 32,
      },
      {
        name: 'Железнодорожная безопасность',
        page: 37,
      },
      {
        name: 'Земляные и траншейные работы',
        page: 41,
      },
      {
        name: 'Грузоподъемные и такелажные работы',
        page: 45,
      },
      {
        name: 'Опасные материалы',
        page: 49,
      },
      {
        name: 'Огневые работы',
        page: 52,
      },
    ],
  },
  {
    name: '3: Дополнительные ресурсы и инструменты',
    subSections: [
      {
        name: 'Работа над водой и у воды',
        page: 56,
      },
      {
        name: 'Упавшие или падающие предметы',
        page: 59,
      },
      {
        name: 'Тестирование атмосферы/Контроль загазованности',
        page: 61,
      },
      {
        name: 'Передача информации о химической опасности',
        page: 65,
      },
    ],
  },
  {
    name: '4: Подходы Cargill к управлению безопасностью',
    subSections: [
      {
        name: 'Ключевые термины',
        page: 70,
      },
      {
        name: 'Определение случаев серьезных травм и травм со смертельным исходом (SIF) ',
        page: 72,
      },
      {
        name: 'Систематизация происшествий, способных привести к серьезным травмам и смертельным случаям (SIFp)',
        page: 73,
      },
      {
        name: 'Таблица критериев автоматического определения SIF',
        page: 74,
      },
      {
        name: 'Личная и корпоративная эффективность (HOP)',
        page: 76,
      },
    ],
  },
];
const RUTableofContent: TableOfContent = {
  language: 'ru',
  sections: RUSection,
  label: 'Оглавление',
  pdfLink:
    'https://en-pdfs-life-on-focus.dev.cglcloud.in/Cargill Field Safety Guide RUSSIAN_(ru_RU)_DIGITAL_CROPPED.pdf',
  hopPocket: 'Карманный справочник по HOP',
  hopPocketLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/HOP pocket guide content 2021-09-08_ru_RU.pdf',
  source: RUSSIAN,
};

export default RUTableofContent;
